import type { ISerialize } from '@/objects/ISerialize';
import type { SearchDataType } from './../enums/SearchDataType';

export class TypeAheadItem implements ISerialize {
    public ID: number;

    public DataType: SearchDataType | null;

    public Description: string | null;

    public Text: string;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { ID?: number; DataType?: SearchDataType | null; Description?: string | null; Text?: string | null }) {
        this.ID = values.ID ?? 0;

        this.DataType = values.DataType ?? 'Event';

        this.Description = values.Description ?? null;

        this.Text = values.Text ?? '';
    }

    public serialize(): string {
        return (
            '{' +
            `"ID": ${JSON.stringify(this.ID)}` +
            ',' +
            `"DataType": ${this.DataType == null ? null : this.DataType == 'Event' ? 1 : this.DataType == 'Race' ? 2 : this.DataType == 'Category' ? 3 : this.DataType == 'Group' ? 4 : this.DataType == 'Station' ? 5 : this.DataType == 'StationRole' ? 6 : this.DataType == 'Participant' ? 7 : this.DataType == 'Contestant' ? 8 : null}` +
            ',' +
            `"Description": ${JSON.stringify(this.Description)}` +
            ',' +
            `"Text": ${JSON.stringify(this.Text)}` +
            '}'
        );
    }

    /**
     * Creates an instance of TypeAheadItem from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        ID?: number;
        DataType?: SearchDataType | null;
        Description?: string | null;
        Text?: string | null;
    }): TypeAheadItem {
        return new TypeAheadItem(values);
    }

    public static _FromServerJson(json: any): TypeAheadItem {
        return new TypeAheadItem({
            ID: json.ID,
            DataType:
                json.DataType == null
                    ? null
                    : json.DataType == 1
                      ? 'Event'
                      : json.DataType == 2
                        ? 'Race'
                        : json.DataType == 3
                          ? 'Category'
                          : json.DataType == 4
                            ? 'Group'
                            : json.DataType == 5
                              ? 'Station'
                              : json.DataType == 6
                                ? 'StationRole'
                                : json.DataType == 7
                                  ? 'Participant'
                                  : json.DataType == 8
                                    ? 'Contestant'
                                    : null,
            Description: json.Description ?? '',
            Text: json.Text ?? '',
        });
    }

    /**
     * Creates an instance of TypeAheadItem from another instance of TypeAheadItem.
     * @param other The TypeAheadItem you want to clone
     * @returns A cloned TypeAheadItem
     */
    public static FromOther(other: TypeAheadItem): TypeAheadItem {
        return TypeAheadItem._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return TypeAheadItem.FromOther(this);
    }

    static NAME_OF_CLASS = 'TypeAheadItem';
}
